import i18n from '@/plugins/i18n'

export default [
  {
    path: 'user/@:alias',
    name: 'UserDetail',
    component: () => import('@/app/M0001User/PgUserDetails.vue'),
    portalGroup: 'all.public',
    meta: { title: i18n.t('m0001.userProfile') }
  },
  {
    path: 'user/:id',
    name: 'UserDetailUsingId',
    component: () => import('@/app/M0001User/PgUserDetails.vue'),
    portalGroup: 'all.public',
    meta: { title: i18n.t('m0001.userProfile') }
  },
  {
    path: 'user',
    name: 'UserList',
    component: () => import('@/app/M0001User/PgUserList.vue'),
    portalGroup: 'all.admin',
    meta: {
      title: i18n.t('m0001.userList'),
      authenticated: true
      // permissions: ['user.manage']
    }
  }
]
